export type PermissionState = "unsupported" | "default" | "granted" | "denied";

export function doesBrowserSupportsDesktopNotifications(): boolean {
  return typeof window !== "undefined" && typeof window.Notification !== "undefined";
}

export function getPermissionState(): PermissionState {
  if (!doesBrowserSupportsDesktopNotifications()) {
    return "unsupported";
  }
  const { permission } = window.Notification;
  return permission === "granted" || permission === "denied" ? permission : "default";
}

/**
 * Asks the browser for notification permission. Must only be called from a user gesture.
 * Never rejects: any failure resolves to the current permission state.
 */
export async function requestNotificationPermission(): Promise<PermissionState> {
  if (getPermissionState() !== "default") {
    return getPermissionState();
  }

  await new Promise<unknown>((resolve, reject) => {
    // Legacy browsers only honor the callback; modern ones return a Promise.
    const pending: Promise<Exclude<PermissionState, "unsupported">> | undefined = window.Notification.requestPermission(resolve);
    if (typeof pending?.then === "function") {
      pending.then(resolve, reject);
    }
  }).catch(() => undefined);

  return getPermissionState();
}
